/**
 * The theme preference, bound to this app's storage key. `public/theme-boot.js`
 * reads the same key before the first paint; keep the two in step, and never
 * change the key, or every saved choice is forgotten.
 */

import { themeStore } from "@vcnet/ui";

export type { Theme } from "@vcnet/ui";

export const { readTheme, applyTheme, useTheme } = themeStore("iltocat.theme");
